module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-ca4f97e1e7e7c5a46d8ff32b02015ca7.webp";